import React from "react";
import { useState } from "react";

import { Button, Stack } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { PopoverContentProps } from "components/AiData/PopoverContent";
import dayjs from "dayjs";
import { useDateFormatSelect } from "store";

export const DatePopoverContent: React.FC<PopoverContentProps> = ({
  openedCell,
  setOpenedCell,
  onChangeSpecificRecommendationValue
}) => {
  const dateFormat = useDateFormatSelect();
  const [date, setDate] = useState<string | null>(openedCell?.data.parameter.date || null);
  return (
    <>
      <DesktopDatePicker
        format={dateFormat}
        views={["year", "month", "day"]}
        value={date ? dayjs(date) : null}
        label="Date"
        onChange={(value) => setDate(value?.format("YYYY-MM-DD") || null)}
        slotProps={{
          textField: { placeholder: "Select" },
          inputAdornment: { position: "start" },
          popper: {
            sx: {
              ".MuiPickersCalendarHeader-labelContainer": {
                fontSize: "0.9rem"
              }
            }
          }
        }}
      />
      {/* <DatePicker label="Date" value={date || ""} onChange={(value) => setDate(value)} /> */}

      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", gap: "10px" }}>
        <Button
          variant="outlined"
          onClick={() => {
            setOpenedCell(null);
            setDate(null);
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={async () => {
            if (openedCell?.data && date) {
              openedCell.data.parameter.id &&
                (await onChangeSpecificRecommendationValue({
                  id: openedCell.data.parameter.id,
                  field: "date",
                  value: date
                }));
            }
            setOpenedCell(null);
          }}
          variant="contained"
        >
          Apply
        </Button>
      </Stack>
    </>
  );
};
